import { useLocation, useNavigate } from "react-router-dom";
import { INavItemProps } from "../types";

export function useNavItem({
  routes,
  title,
  count,
  handleClick,
}: INavItemProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const selected = routes.includes(location.pathname);

  const handleOnClick =
    handleClick ??
    (() => {
      navigate(routes[0]);
    });

  return { selected, handleClick: handleOnClick, location, title, count };
}
